import APIClient from '../../../lib/api';

const DEFAULT_PAGE_SIZE = 25;

class QuotePackageService {
  async getAll(params = {}) {
    const defaultParams = {
      skip: 0,
      limit: DEFAULT_PAGE_SIZE,
      active_only: true,
    };

    const queryParams = { ...defaultParams, ...params };

    try {
      const response = await APIClient.quotePackages.getAll(queryParams);
      const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
      return {
        success: true,
        data,
        total: response.data?.total ?? data.length,
      };
    } catch (error) {
      console.error('QuotePackageService.getAll error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης πακέτων προσφορών',
      };
    }
  }

  async getById(packageId) {
    try {
      const response = await APIClient.quotePackages.getById(packageId);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('QuotePackageService.getById error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης πακέτου προσφοράς',
      };
    }
  }

  async getSections(packageId) {
    try {
      const response = await APIClient.quotePackages.getSections(packageId);
      return {
        success: true,
        data: response.data || [],
      };
    } catch (error) {
      console.error('QuotePackageService.getSections error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης ενοτήτων πακέτου',
      };
    }
  }

  async create(payload) {
    try {
      const response = await APIClient.quotePackages.create(payload);
      return {
        success: true,
        data: response.data,
        message: 'Το πακέτο προσφοράς δημιουργήθηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.create error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας πακέτου προσφοράς',
        errorResponse: error.response?.data,
      };
    }
  }

  async update(packageId, payload) {
    try {
      const response = await APIClient.quotePackages.update(packageId, payload);
      return {
        success: true,
        data: response.data,
        message: 'Το πακέτο προσφοράς ενημερώθηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.update error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης πακέτου προσφοράς',
      };
    }
  }

  async delete(packageId) {
    try {
      await APIClient.quotePackages.delete(packageId);
      return {
        success: true,
        message: 'Το πακέτο προσφοράς διαγράφηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.delete error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής πακέτου προσφοράς',
      };
    }
  }

  async duplicate(packageId) {
    try {
      const response = await APIClient.quotePackages.duplicate(packageId);
      return {
        success: true,
        data: response.data,
        message: 'Το πακέτο προσφοράς αντιγράφηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.duplicate error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα αντιγραφής πακέτου προσφοράς',
      };
    }
  }

  async createSection(packageId, payload) {
    try {
      const response = await APIClient.quotePackages.createSection(packageId, payload);
      return {
        success: true,
        data: response.data,
        message: 'Η ενότητα προστέθηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.createSection error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας ενότητας',
      };
    }
  }

  async updateSection(packageId, sectionId, payload) {
    try {
      const response = await APIClient.quotePackages.updateSection(packageId, sectionId, payload);
      return {
        success: true,
        data: response.data,
        message: 'Η ενότητα ενημερώθηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.updateSection error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης ενότητας',
      };
    }
  }

  async deleteSection(packageId, sectionId) {
    try {
      await APIClient.quotePackages.deleteSection(packageId, sectionId);
      return {
        success: true,
        message: 'Η ενότητα διαγράφηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuotePackageService.deleteSection error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής ενότητας',
      };
    }
  }
}

const quotePackageService = new QuotePackageService();
export default quotePackageService;

